export default {
    liveChart: {
        datasetLabel: '{product} profile',
        binLabel: 'Bin {index}',
        ariaLabel: 'Profile chart for {date}, {product}, {count} bins',
    },
}
